import { render, staticRenderFns } from "./ed-student-list-class.component.vue?vue&type=template&id=5f99adca&scoped=true&"
import script from "./ed-student-list-class.component.ts?vue&type=script&lang=ts&"
export * from "./ed-student-list-class.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-student-list-class.component.scss?vue&type=style&index=0&id=5f99adca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f99adca",
  null
  
)

export default component.exports